import {
    APP,
    ALIGN,
} from '_pixiSrc/globals';
import I18 from '_pixiSrc/I18';
import Static from '_libraries/Static';
import Paytable from './Paytable';
import AudioManager from './AudioManager';
import ScreenLocker from './ScreenLocker';
import Button from './Button';
import SliderButton from './SliderButton';

const whiteColorText = {
    fill: 0XFFFFFF,
    align: ALIGN.LEFT,
    size: 25,
};

const goldenColorText = {
    fill: 0xfcd781,
    align: ALIGN.LEFT,
    weight: 'bold',
    size: 25,
};

/**
 * @class Options
 * @classdesc Create option layout and return sprite containing it.
 */
class Options {
    /**
     * to create option layout and return it
     * @static
     * @param {number} [x=0]
     * @param {number} [y=0]
     * @param {*} paytable paytable layout to open
     */
    static invoke(x = 0, y = 0, paytableParent) {
        // if already open then close it and return
        if (this.isOpen) {
            this.close();
            return;
        }

        Paytable.close();

        // screen overlay for layout
        this.container = new ScreenLocker(0X270029, 0.9);
        this.container.position.set(x, y);

        this.paytableParent = paytableParent;

        this.isOpen = true;

        // mobile layout box
        this.container.box = this.container.addChild(APP.library.getSprite('buttons/buttons/option-background'));
        this.container.box.scale.set(0.8);

        // write all heading texts
        this.writeText();

        // add slider buttons and paytable button
        this.addButtons();

        return this.container;
    }

    /**
     * used to write heading texts
     * @static
     */
    static writeText() {
        Static.writeNativeText(this.container.box, I18.f('opOptions'), 'lato-regular', -150, -105, goldenColorText);

        // Static.writeNativeText(this.container.box, I18.f('opTurbo'), 'lato-regular', -150, -100, whiteColorText);

        // Static.writeNativeText(this.container.box, I18.f('opAutoTurbo'), 'lato-regular', -150, -35, whiteColorText);

        Static.writeNativeText(this.container.box, I18.f('opSound'), 'lato-regular', -150, -43, whiteColorText);

        Static.writeNativeText(this.container.box, I18.f('opMusic'), 'lato-regular', -150, 23, whiteColorText);
    }

    /**
     * used to add slider buttons and paytable button
     * @static
     */
    static addButtons() {
        const mobileButtonState = {
            normal: 0,
            hover: 0,
            pressed: 1,
            disable: 2,
        };
        // // turbo button
        // this.container.box.addChild(new SliderButton(110, -100, 1, 'isTurboChecked'));

        // // auto turbo button
        // this.container.box.addChild(new SliderButton(110, -35, 1, 'isAutoTurboChecked'));

        // sound button
        this.container.box.addChild(new SliderButton(110, -40, 1, 'soundEnabled', (isOn) => {
            if (!isOn) {
                AudioManager.stopAllSounds();
            }
        }));

        // music button
        this.container.box.addChild(new SliderButton(110, 25, 1, 'musicEnabled', (isOn) => {
            if (!isOn) {
                AudioManager.muteMusicOnDisabled();
                return;
            }
            AudioManager.resumeMusic();
        }));


        // paytable button
        const paytable = this.container.box.addChild(new Button('buttons/buttons/popup-button', -13, 93, 1, () => {
            // add paytable to parent of current option layout
            const parent = this.paytableParent ? this.paytableParent : this.container.parent;
            parent.addChild(Paytable.invoke());

            // close option layout
            this.close();
        }));
        paytable.hitArea = new PIXI.RoundedRectangle(-153, -30, 306, 52, 15);
        paytable.text = Static.writeNativeText(paytable, I18.f('opPaytable'), 'lato-regular', 10, 0, {
            fill: 0xfcd781,
            size: 22,
            align: ALIGN.CENTER,
            weight: 'bold',
        });

        // close button
        const closeButton = this.container.box.addChild(new Button('buttons/buttons/close', 130, -102, 0.8, () => {
            this.close();
        }));

        closeButton.hitArea = new PIXI.Circle(0, 0, 38);
    }


    /**
     * close option layout
     */
    static close() {
        if (this.isOpen) {
            this.container.safeRemove();
            this.container = null;
            this.buttonContainer = null;
            this.isOpen = false;
            if (this.callback) {
                this.callback();
            }
            this.callback = null;
        }
    }

    /**
     * passCloseCallback is used to give callback to paytable so it call it on close
     * @param  {Function} callback to call on close
     */
    static passCloseCallback(callback) {
        this.callback = callback;
    }
}

export default Options;
